<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<h3>KIKBLOX</h3>
	<mat-spinner diameter="40"></mat-spinner>
</div>
